import { Icons } from '@/components/atoms/Icons/Icons.tsx'
import { cn } from '@/lib/utils.ts'

export interface SortButtonProps {
  className?: string
  disabled?: boolean
  sortBy: 'asc' | 'desc'
  onSortChanged: (value: 'asc' | 'desc') => void
}

export const SortButton = ({ className, disabled, sortBy, onSortChanged }: SortButtonProps) => (
  <button
    type="button"
    className={cn(className)}
    disabled={disabled}
    onClick={() => {
      onSortChanged(sortBy === 'asc' ? 'desc' : 'asc')
    }}>
    {sortBy === 'asc' ? (
      <Icons.ascdending className="h-4 w-5 fill-gray-500" />
    ) : (
      <Icons.descending className="h-4 w-5 fill-gray-500" />
    )}
  </button>
)
